<template>
  <!-- Kontener filtru naruszeń wyświetlany tylko, gdy istnieje wybrane naruszenie -->
  <div v-if="isChoosen()" class="filter d-flex flex-column">
    <!-- Nagłówek sekcji z tytułem i ikoną usuwania wszystkich filtrów -->
    <h5 class="margin-0">
      {{ t('violations') }}
      <!-- Ikona kosza: usuwa wszystkie zaznaczone naruszenia -->
      <span class="icon-trash" @click="removeFilter()" role="button"></span>
    </h5>

    <!-- Iteracja po wszystkich dostępnych naruszeniach z store -->
    <div
      v-for="(violation, name) in store.violations"
      :key="name"
      class="collapse show"
      id="violations"
    >
      <!-- Wyświetl tylko te naruszenia, które są zaznaczone w filtrach -->
      <div v-if="store.filters[name]" class="info d-flex">

        <!-- Checkbox reprezentujący pojedyncze naruszenie -->
        <input-checkbox
          :field-name="name"
          field-value=""
          :checkedCondition="true"
          @clicked="setFilter(name)"
          vio="vio"
        />

        <!-- Etykieta z nazwą naruszenia (tłumaczona) -->
        <p class="m-0">{{ violation }}</p>
      </div>
    </div>
  </div>
</template>

<script>
// Import komponentu input-checkbox do zaznaczania/odznaczania naruszeń
import InputCheckbox from "../InputCheckbox.vue";

export default {
  name: "ViolationFilterView",  // Nazwa komponentu

  props: {
    // Store zawierający filtry i dane o naruszeniach
    store: { required: true },
  },

  components: { InputCheckbox }, // Rejestracja komponentu checkbox

  methods: {
    /**
     * Sprawdza, czy którykolwiek filtr naruszeń jest wybrany
     * @returns {boolean}
     */
    isChoosen() {
      const filters = this.store.filters;
      return Object.keys(this.store.violations).some(key => filters[key] === true);
    },

    /**
     * Przełącza stan filtra danego naruszenia:
     * - jeśli jest zaznaczone, odznacza (ustawia false)
     * - jeśli nie jest, zaznacza (ustawia true)
     * @param {string} id - klucz filtra (nazwa naruszenia)
     */
    setFilter(id) {
      const value = this.store.filters[id] ? false : true;
      this.store.addItem(id, value);
    },

    /**
     * Usuwa wszystkie filtry naruszeń z store
     */
    removeFilter() {
      this.store.removeItem("violations");
    },
  },
};
</script>

<style scoped>
/* Ustawienia kontenera filtra */
.filter {
  width: 100%;
}

/* Styl nagłówka z białym tłem i ikoną */
.filter h5 {
  padding: 10px 20px;
  background-color: white;
  position: relative;
  background: white url("../../assets/h-filter-bg.png") repeat-y right top;
}

/* Styl elementów collapse (pojedynczych wierszy) */
.filter .collapse {
  margin: 3px 0;
}

/* Styl wiersza info z checkboxem i etykietą */
.info {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 15px;
  padding: 10px;
  padding-left: 27px;
  font-size: 12px;
}

/* Styl ikony kosza */
.icon-trash {
  background: url("../../assets/icons/trash.svg") no-repeat left top;
  width: 15px;
  height: 17px;
  position: absolute;
  cursor: pointer;
  top: 11px;
  right: 10px;
}
</style>